export const ESTADOS = ["Nuevo", "Contactado", "Reunión", "Propuesta", "Reserva", "Contrato", "Cerrado"];
export const ORIGENES = ["Web", "LinkedIn", "Instagram", "Referido", "Agente", "Expat community", "Google Ads", "Meta Ads", "Otro"];
export const PERFILES = ["Inversor puro", "Uso personal + inversión", "Digital nomad"];
export const INTERESES = ["Caliente", "Tibio", "Frío"];
export const PRIORIDADES = ["Alta", "Media", "Baja"];
export const TIPOS_CONTACTO = ["Llamada", "Email", "WhatsApp", "Reunión", "Visita"];
export const EMPLEADOS = ["Silvia", "Roco", "Saul", "Ignacio", "Miriam"];
export const EMPLEADOS_EMAILS = {
  "Silvia": "Silvimc96@gmail.com",
  "Roco": "rocooop1704@gmail.com",
  "Saul": "saulsk825@gmail.com",
  "Ignacio": "ignacio.internacional73@gmail.com",
  "Miriam": "miri.ferrealso@gmail.com",
};

export const ESTADO_COLORS = {
  "Nuevo": "#3b82f6",
  "Contactado": "#06b6d4",
  "Reunión": "#f59e0b",
  "Propuesta": "#a855f7",
  "Reserva": "#f97316",
  "Contrato": "#8b5cf6",
  "Cerrado": "#22c55e",
};

export const INTERES_META = {
  "Caliente": { dot: "#ef4444", chip: "bg-red-50 text-red-600 border-red-200" },
  "Tibio": { dot: "#f59e0b", chip: "bg-amber-50 text-amber-600 border-amber-200" },
  "Frío": { dot: "#0ea5e9", chip: "bg-sky-50 text-sky-600 border-sky-200" },
};

export const PRECIO_DEFAULT = 59600;

export const day = (offset) => {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
};

export const fmtMoney = (n) => `${Number(n).toLocaleString("es-ES")} €`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
};

export const relDate = (iso) => {
  if (!iso) return "";
  const today = day(0);
  if (iso === today) return "Hoy";
  if (iso === day(1)) return "Mañana";
  if (iso === day(-1)) return "Ayer";
  if (iso < today) return "Vencida";
  return "";
};

export const uid = () => Math.random().toString(36).slice(2, 10);
